import React from "react";
// const backimg = `/Assets/Assets/img/banner1.jpg`

export const Banner = () => {
  return (
    <section className="banner ">
       <div className="main-banner">
       <div className="slide">
         {/* <div className="container">
           
         </div> */}
      </div>
       <div className="container">
       <div className="banner-content">
          <h1>
            INSPIRED FOR 
          </h1>
            <div className="heading-two">
                 <h2 className="anim-typewriter"> INOVATION</h2>
            </div>
           <h4>
            We are Empowering Businesses with Innovative Technology Aspiring to
            become your "Success Partner"
            </h4>
                 <a href="/" className="glbl-btn">
            Get In Touch
          </a>
            </div>
       </div>
       </div>
    </section>
  );
};
